import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormDoneService } from '../../_services/form-done.service';
import { AuthenticationService } from './../../_services/index';
import {MatDialog} from '@angular/material';
import {DialogComponent} from '../dialog/dialog.component';
import { Subscription } from 'rxjs/Subscription';
import { FormBuilder, Validators } from '@angular/forms';
import { ValidationService } from './../../validation.service';
import { AuthService } from 'angular4-social-login';
import { SocialUser } from 'angular4-social-login';
import { UserService } from './../../_services/index';
import * as jwt_decode from 'jwt-decode';
//import { FacebookLoginProvider, GoogleLoginProvider } from 'angular4-social-login';
import { CookieService } from 'ngx-cookie';

import { DomSanitizer } from '@angular/platform-browser'
import { PipeTransform, Pipe } from "@angular/core";

@Pipe({ name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}

declare var $;
@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css'],
  providers: [FormDoneService, AuthenticationService]

})
export class IndexComponent implements OnInit, OnDestroy {

  url;
  content;
  history;
  matchingfunds;
  eligibility;
  applicationProcess;
  showMoreHistory= false;
  historyRest;
  headerdataSub: Subscription;
  ErrorMassage: any;
  loginForm: any;
  currentUser = [];
  returnUrl: string;
  public errorFlag = false;
  loading = false;
  formChangeSub: Subscription;
  email;
  password;
  confirm_password;
  firstname;
  lastname;
  username;
  getdataSub: Subscription;
  user: SocialUser;
  loginSub: Subscription;
  mainsite = true;
  headerImage;
  isCNIC = false;
  blankString = '<div class="NoHeader">&nbsp;</div>';

  constructor(private router: Router,
    private formapi: FormDoneService,
    private loginservice: AuthenticationService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private api: FormDoneService,
    private authService: AuthService,
    private userservice: UserService,
    private _cookieService: CookieService,
  ) {

  }

  ngOnInit() {
    if (localStorage.getItem('currentUser') != null) {
      this.router.navigate(['/user-dashboard']);
    }
    this.getHeaderData();
    this.validateLoginForm();
    this.checkCinc();

  }

    // trueFalseShowMoreHistory(v) {
    //   if (v == false) {
    //       this.showMoreHistory = true;
    //   } else {
    //       this.showMoreHistory = false;
    //   }
    // }

  getHeaderData() {
    const getDomainName = this.loginservice.getDomainName();
    const parts = window.location.hostname.split(getDomainName);
    const countLength = parts.length;
    const subdomain = parts.shift();
    console.log(countLength);
    if (countLength === 2) {
      this.mainsite = false;
      this.formapi.getHeaderData$(subdomain).subscribe(
        responsedata => {
          const headerData  = responsedata.data;
          this.headerImage = headerData.headerImage.full_path;

          if (this.headerImage == null && this.headerImage =='') {
            this.headerImage = "assets/img/banner.jpg";
          }

          this.url          = headerData.url;
          this.content      = headerData.content;
          const history     = headerData.history.split('</p>');
          this.history      = history[0];
          history.splice(0, 1);
          this.historyRest        = history.join(' ');
          this.matchingfunds      = headerData.maching_funds;
          this.matchingfunds      = (!!this.matchingfunds)?this.matchingfunds.replace('OneFuture Coachella Valley (OFCV)', headerData.org_name):'';
          this.eligibility        = headerData.elig_req;
          this.applicationProcess = headerData.ap_process;

        },
        error => {
          console.log(error);
        },
      );
    }

  }

  openDialog() {
    const dialogRef = this.dialog.open(DialogComponent, {
      height: '600px'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  showHistoryRest() {
    console.log(this.showMoreHistory);
    if (this.showMoreHistory === true) {
      this.showMoreHistory  = false;
    } else {
      this.showMoreHistory = true;
    }

  }

  ngOnDestroy() {
    if (this.headerdataSub)  {
      this.headerdataSub.unsubscribe();
    }
  }

  validateLoginForm() {
    this.loginForm = this.formBuilder.group({
      'email': ['', [Validators.required]],
      'password': ['', [Validators.required]]
    });
  }

  loginUser() {
    this.returnUrl = localStorage.getItem('return-url');
    console.log(this.returnUrl);
    localStorage.removeItem('return-url');
    this.loading = true;
    this.loginSub = this.loginservice.authenticate(
      this.loginForm.value.email, this.loginForm.value.password
    ).subscribe(
      (dataResponse) => {
        const response = dataResponse;
        if (response.success === 1 && response.statusCode === 200) {
          this.errorFlag = false;
          localStorage.setItem('currentUser', JSON.stringify(response.data));
          const token = response.data.token;
          localStorage.setItem('token', 'Bearer ' + token);
          const decoded = jwt_decode(token);
          const exp = decoded.exp;
          const date = new Date(exp * 1000);
          const getDomainName = this.loginservice.getDomainName();
          const parts = window.location.hostname.split(getDomainName);

          const countLength = parts.length;

          const subdomain = parts.shift();
          if (countLength === 1) {
            this._cookieService.put('token', 'Bearer ' + token, {
              domain: getDomainName,
              expires: date
            });
          }
          if (countLength === 2) {
            this._cookieService.put('token', 'Bearer ' + token, {
              domain: getDomainName,
              expires: date
            });
          }
          this.errorFlag = false;
          this.loading = false;
          this.getdataSub = this.api.getFormData('Bearer ' + token)
          .subscribe(responsedata => {
            const formdata = responsedata.data;
            const personalinformation = formdata.personalinformation;
            const academicinformation = formdata.academicinformation;
            const backgroundinformation = formdata.backgroundinformation;
            const priorhighereducation = formdata.priorhighereducation;
            const futurecollegeplans = formdata.futurecollegeplans;
            const academiccareergoals = formdata.academiccareergoals;
            const extracurrucaullar = formdata.extracurrucaullar;
            const employment = formdata.employment;
            const profileupload = formdata.profileupload;

            if(this.returnUrl){
              this.router.navigate([this.returnUrl]);
            }
            else{
              if (profileupload > 0) {
                this.router.navigate(['/user-dashboard']);
              } else {
                this.router.navigate(['/profile-upload']);
              }
            }

          });
        }
      },
      error => {
        this.loading = false;
        let errordata = error;
        if(this.isJSON(error._body)){
          errordata = JSON.parse(error._body);
        }
        else{
          errordata = error;
        }
        if (errordata.success === 0) {
          this.ErrorMassage = errordata.message;
          this.errorFlag = true;
        }

      }
    );
  }

  isJSON(str) {
    try {
        return (JSON.parse(str) && !!str);
    } catch (e) {
        return false;
    }
  }

  /* signInWithGoogle(): void {
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
    this.formChangeSub = this.authService.authState.subscribe((user) => {
      //this.user = user;
      if(user) {
        console.log(user);
        this.email = user.email;
        this.password = user.id
        this.confirm_password = user.id
        this.firstname = user.firstName;
        this.lastname = user.lastName ;
        this.username  = user.name;
        this.userservice.socialSignup(
            this.email, this.password,
            this.confirm_password, this.firstname,
            this.lastname, this.username
          ).subscribe(
            (dataResponse) => {

              console.log(dataResponse);
              const response = dataResponse;
              if (response.success === 1 && response.statusCode === 200) {
                this.errorFlag = false;
                this.loading = false;
                this.ErrorMassage = response.message;

                this.loginservice.socialauthenticate(
                  this.email, this.password
                ).subscribe(
                  (dataResponse) => {
                    const response = dataResponse;
                    if (response.success === 1 && response.statusCode === 200) {
                      this.errorFlag = false;
                      localStorage.setItem('currentUser', JSON.stringify(response.data));
                      const token = response.data.token;
                      localStorage.setItem('token', 'Bearer ' + token);
                      this.errorFlag = false;

                      const decoded = jwt_decode(token);
                      const exp = decoded.exp;
                      const date = new Date(exp * 1000);
                      const getDomainName = this.loginservice.getDomainName();
                      const parts = window.location.hostname.split(getDomainName);

                      const countLength = parts.length;

                      const subdomain = parts.shift();
                      if (countLength === 1) {
                        this._cookieService.put('token', 'Bearer ' + token, {
                          domain: getDomainName,
                          expires: date
                        });
                      }
                      if (countLength === 2) {
                        this._cookieService.put('token', 'Bearer ' + token, {
                          domain: getDomainName,
                          expires: date
                        });
                      }

                      this.loading = false;
                      this.router.navigate(['/user-dashboard']);
                    }
                  },
                  error => {
                    this.loading = false;
                    const errordata = JSON.parse(error._body);
                    if (errordata.success === 0) {
                      this.ErrorMassage = errordata.message;
                      this.errorFlag = true;
                    }
                  }
                );
              }
          },
          error => {
            this.loading = false;
            const errordata = JSON.parse(error._body);

            console.log(errordata);
            if (errordata.success === 0 && errordata.message === 'You are already registered!') {
              this.loginservice.socialauthenticate(
                this.email, this.password
              ).subscribe(
                (dataResponse) => {
                  const response = dataResponse;
                  if (response.success === 1 && response.statusCode === 200) {
                    this.errorFlag = false;
                    localStorage.setItem('currentUser', JSON.stringify(response.data));
                    const token = response.data.token;
                    localStorage.setItem('token', 'Bearer ' + token);

                    const decoded = jwt_decode(token);
                    const exp = decoded.exp;
                    const date = new Date(exp * 1000);
                    const getDomainName = this.loginservice.getDomainName();
                    const parts = window.location.hostname.split(getDomainName);

                    const countLength = parts.length;

                    const subdomain = parts.shift();
                    if (countLength === 1) {
                      this._cookieService.put('token', 'Bearer ' + token, {
                        domain: getDomainName,
                        expires: date
                      });
                    }
                    if (countLength === 2) {
                      this._cookieService.put('token', 'Bearer ' + token, {
                        domain: getDomainName,
                        expires: date
                      });
                    }

                    this.errorFlag = false;
                    this.loading = false;
                    this.router.navigate(['/user-dashboard']);
                  }
                },
                error => {
                  this.loading = false;
                  const errordata = JSON.parse(error._body);
                  if (errordata.success === 0) {
                    this.ErrorMassage = errordata.message;
                    this.errorFlag = true;
                  }
                }
              );

            }
          }
        );
      }
    });
  }

  signInWithFB(): void {
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
    this.formChangeSub = this.authService.authState.subscribe((user) => {
      //this.user = user;
      if(user) {
        console.log(user);
        this.email = user.email;
        this.password = user.id
        this.confirm_password = user.id
        this.firstname = user.firstName;
        this.lastname = user.lastName ;
        this.username  = user.name;
        this.userservice.socialSignup(
            this.email, this.password,
            this.confirm_password, this.firstname,
            this.lastname, this.username
          ).subscribe(
            (dataResponse) => {

              console.log(dataResponse);
              const response = dataResponse;
              if (response.success === 1 && response.statusCode === 200) {
                this.errorFlag = false;
                this.loading = false;
                this.ErrorMassage = response.message;

                this.loginservice.socialauthenticate(
                  this.email, this.password
                ).subscribe(
                  (dataResponse) => {
                    const response = dataResponse;
                    if (response.success === 1 && response.statusCode === 200) {
                      this.errorFlag = false;
                      localStorage.setItem('currentUser', JSON.stringify(response.data));
                      const token = response.data.token;
                      localStorage.setItem('token', 'Bearer ' + token);

                      const decoded = jwt_decode(token);
                      const exp = decoded.exp;
                      const date = new Date(exp * 1000);
                      const getDomainName = this.loginservice.getDomainName();
                      const parts = window.location.hostname.split(getDomainName);

                      const countLength = parts.length;

                      const subdomain = parts.shift();
                      if (countLength === 1) {
                        this._cookieService.put('token', 'Bearer ' + token, {
                          domain: getDomainName,
                          expires: date
                        });
                      }
                      if (countLength === 2) {
                        this._cookieService.put('token', 'Bearer ' + token, {
                          domain: getDomainName,
                          expires: date
                        });
                      }

                      this.errorFlag = false;
                      this.loading = false;
                      this.router.navigate(['/user-dashboard']);
                    }
                  },
                  error => {
                    this.loading = false;
                    const errordata = JSON.parse(error._body);
                    if (errordata.success === 0) {
                      this.ErrorMassage = errordata.message;
                      this.errorFlag = true;
                    }
                  }
                );
              }
          },
          error => {
            this.loading = false;
            const errordata = JSON.parse(error._body);

            console.log(errordata);
            if (errordata.success === 0 && errordata.message === 'You are already registered!') {
              this.loginservice.socialauthenticate(
                this.email, this.password
              ).subscribe(
                (dataResponse) => {
                  const response = dataResponse;
                  if (response.success === 1 && response.statusCode === 200) {
                    this.errorFlag = false;
                    localStorage.setItem('currentUser', JSON.stringify(response.data));
                    const token = response.data.token;
                    localStorage.setItem('token', 'Bearer ' + token);

                    const decoded = jwt_decode(token);
                    const exp = decoded.exp;
                    const date = new Date(exp * 1000);
                    const getDomainName = this.loginservice.getDomainName();
                    const parts = window.location.hostname.split(getDomainName);

                    const countLength = parts.length;

                    const subdomain = parts.shift();
                    if (countLength === 1) {
                      this._cookieService.put('token', 'Bearer ' + token, {
                        domain: getDomainName,
                        expires: date
                      });
                    }
                    if (countLength === 2) {
                      this._cookieService.put('token', 'Bearer ' + token, {
                        domain: getDomainName,
                        expires: date
                      });
                    }

                    this.errorFlag = false;
                    this.loading = false;
                    this.router.navigate(['/user-dashboard']);
                  }
                },
                error => {
                  this.loading = false;
                  const errordata = JSON.parse(error._body);
                  if (errordata.success === 0) {
                    this.ErrorMassage = errordata.message;
                    this.errorFlag = true;
                  }
                }
              );

            }
          }
        );
      }
    });
  } */

  checkCinc(){
    const getDomainName = this.loginservice.getDomainName();
    const parts = window.location.hostname.split(getDomainName);
    //const countLength = parts.length;
    const subdomain = parts.shift();
    console.log(subdomain);
    if(subdomain == 'cinc'){
      this.isCNIC = true;
    }
    else{
      this.isCNIC = false;
    }
  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/index/index.component.ts